module.exports = __webpack_public_path__ + "img/icon-26.0df53b45.png";